module.exports = __webpack_public_path__ + "static/15-Usability-Testing-fcf0abd6a9c631a01c6d4147edf7880e.jpg";